import Context from "../context/context";
import React, { useContext } from 'react';
import Checkboxes from "./Checkboxes";

function SideFilterSection(props){
    const {data} = props;
    const {
        activeFilters, setActiveFilters,
        selectedFilters, setSelectedFilters,
    } = useContext(Context);


    let selected = false;
    if (data.name === activeFilters.active_side_filter){
        selected = true;
    }


    const handleFilterBackClick = () => {
        let active_filters = activeFilters;

        active_filters.active_side_filter = "";

        setActiveFilters(
            {...activeFilters},
            active_filters
        )
    }

    const closeFilterPanel = () => {
        let active_filters = {
            mobile_open: false,
            active_panel: 'side_filter',
            top_filter_open: false,
            side_filter_open: false,
            active_side_filter: '',
            active_date_panel: ''
        };


        setActiveFilters(
          active_filters
        )
    }


    const resetFilters = () => {

        let selected_filters = selectedFilters.map((selected_filter) => {
            if (selected_filter.name === data.name){
                if (data.type === "checkboxes") {
                    selected_filter.elements.forEach((element) => {
                        element.value = false;
                    })
                }


            }
            return selected_filter;
        })
        setSelectedFilters(selected_filters);
    }



    return (
        <>
            <div className={`side-filter-section ${selected ? "active" : ""}`} >
            <div className={`side-filters-nav-bg `}></div>

            <div className="side-filter-section-inner">
              <div className="side-filter-section-top">
              <button className="filters-back" onClick={() => handleFilterBackClick()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="11" viewBox="0 0 9 11" fill="none">
                      <path d="M6 2.5L3 5.5L6 8.5" stroke="#091F2C" strokeWidth="3" strokeLinecap="square"/>
                  </svg>
                  Back to filters
              </button>
              <div className="side-filter-title">Filter by:</div>
              </div>

                {data.type === "checkboxes" &&
                    <Checkboxes data={data}/>
                }


            </div>

                <div className="filter-actions">
                    <button
                    className="filter-action view button button-white"
                    onClick={() => closeFilterPanel()}
                    >
                    View results
                    </button>
                    <button
                        className="filter-action reset button"
                        onClick={() => resetFilters()}
                    >
                    Reset theses filters
                    </button>
                </div>
            </div>


        </>
    )
}

export default SideFilterSection;
